import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false // Needed to update when language changes
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(
    value: Date | string | number,
    format: string = 'medium'
  ): string | null {
    const currentLang = this.translate.currentLang || 'en';
    const locale = currentLang === 'ar' ? 'ar-EG' : 'en-US';
    return new DatePipe(locale).transform(value, format);
  }
}
